import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { sectionBaca } from './style';

const TipeTulisan = ({
    tulisannya
  }) => {
  return (
      <div className={sectionBaca}>
         {tulisannya !== '...'
          && (
                                <div className="tulisanChapter">
                                {tulisannya}
                            </div>)}

        {tulisannya === '...'
          && (
                                <div className="tulisanChapterTitik">
                                {tulisannya}
                            </div>)}
        
    </div>
  );
};
export default TipeTulisan;
